import { styled } from '@mui/material'
import { memo } from 'react'
import { Ether, TokenSymbol } from 'types'
import { isZero } from 'utils/number'

export const TipsMinAmount = styled('div')`
  color: ${(props) => props.theme.color.sell30};
  font-size: 12px;
  margin-top: 4px;
  margin-left: 2px;
`

export const MinimumSizeCheck = memo<{
  currentAmount: Ether
  baseCurrency: TokenSymbol
  minimumSize: Ether
}>(({ currentAmount, baseCurrency, minimumSize }) => {
  if (currentAmount === undefined || currentAmount === '') return null
  if (isZero(minimumSize)) return null
  if (Number(currentAmount) >= Number(minimumSize)) return null

  return (
    <TipsMinAmount>
      The order amount minimum of {minimumSize} {baseCurrency}
    </TipsMinAmount>
  )
})
